// Utility functions for store timing
export const isStoreOpen = (fromTime, toTime) => {
  if (!fromTime || !toTime) return true; // If no timing data, assume store is open
  
  const now = new Date();
  const currentTime = now.getHours() * 60 + now.getMinutes(); // Convert to minutes
  
  // Parse opening time
  const [fromHour, fromMinute] = fromTime.split(':').map(Number);
  const openingTime = fromHour * 60 + fromMinute;
  
  // Parse closing time
  const [toHour, toMinute] = toTime.split(':').map(Number);
  const closingTime = toHour * 60 + toMinute;
  
  // If opening and closing times are the same, consider store always open
  if (openingTime === closingTime) {
    return true;
  }
  
  // Handle cases where store is open past midnight
  if (closingTime < openingTime) {
    // Store closes after midnight
    return currentTime >= openingTime || currentTime <= closingTime;
  } else {
    // Store closes before midnight
    return currentTime >= openingTime && currentTime <= closingTime;
  }
};

export const formatTime = (timeString) => {
  if (!timeString) return 'N/A';
  return new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

export const getNextOpeningTime = (fromTime) => {
  if (!fromTime) return null;
  
  const now = new Date();
  const [fromHour, fromMinute] = fromTime.split(':').map(Number);
  const nextOpening = new Date(now);
  
  // Set to next opening time
  nextOpening.setHours(fromHour, fromMinute, 0, 0);
  
  // If today's opening time has passed, set to tomorrow
  if (nextOpening <= now) {
    nextOpening.setDate(nextOpening.getDate() + 1);
  }
  
  return nextOpening;
};
